export default "__VITE_ASSET__DsAWy3rT__"